/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Gestion du menu de tags hiérarchique
document.addEventListener('DOMContentLoaded', function () {
	const blogTagMenuItems = document.querySelectorAll('.blog-tag-menu__item--dropdown');

	blogTagMenuItems.forEach(function (item) {
		const link = item.querySelector('.blog-tag-menu__link--parent');
		const dropdown = item.querySelector('.blog-tag-dropdown');

		if (link && dropdown) {
			let hoverTimeout;

			// Fonction pour ouvrir le dropdown
			function openDropdown() {
				clearTimeout(hoverTimeout);
				link.setAttribute('aria-expanded', 'true');
				dropdown.setAttribute('aria-hidden', 'false');
			}

			// Fonction pour fermer le dropdown avec délai
			function closeDropdown() {
				hoverTimeout = setTimeout(function () {
					link.setAttribute('aria-expanded', 'false');
					dropdown.setAttribute('aria-hidden', 'true');
				}, 150); // Petit délai pour éviter la fermeture accidentelle
			}

			// Événements sur l'élément parent
			item.addEventListener('mouseenter', openDropdown);
			item.addEventListener('mouseleave', closeDropdown);

			// Événements sur le dropdown pour maintenir ouvert
			dropdown.addEventListener('mouseenter', function () {
				clearTimeout(hoverTimeout);
			});

			dropdown.addEventListener('mouseleave', closeDropdown);

			// Support du clavier
			link.addEventListener('keydown', function (e) {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					const isExpanded = link.getAttribute('aria-expanded') === 'true';

					if (isExpanded) {
						closeDropdown();
					} else {
						openDropdown();
					}
				}

				if (e.key === 'Escape') {
					closeDropdown();
				}
			});

			// Fermer le dropdown quand on clique ailleurs
			document.addEventListener('click', function (e) {
				if (!item.contains(e.target)) {
					link.setAttribute('aria-expanded', 'false');
					dropdown.setAttribute('aria-hidden', 'true');
				}
			});
		}
	});
});
